import './src/styles/global.css'
import "@fontsource/montserrat/800.css"
import "@fontsource/montserrat"
import "typeface-nunito-sans";
import React from 'react';
import { GlobalStateProvider } from './src/components/general/globalState';
import { Analytics } from "@vercel/analytics/react";
import { config } from '@fortawesome/fontawesome-svg-core';
// Disable Font Awesome CSS auto-injection to prevent FOUT/FOIT
config.autoAddCss = false;

export const onClientEntry = () => {
  if (typeof document !== 'undefined') {
    document.documentElement.classList.add('notranslate');
    document.body.classList.add('notranslate');
    document.documentElement.setAttribute('translate', 'no');
    document.body.setAttribute('translate', 'no');
    document.documentElement.setAttribute('lang', 'en');

    // Initialize Crisp on all pages (client-side only)
    if (typeof window !== 'undefined') {
      window.$crisp = window.$crisp || [];
      window.CRISP_WEBSITE_ID = "77a8de3e-b0c2-4253-bd4e-7e8f7d3949a3";
      if (!document.getElementById('crisp-chat')) {
        const s = document.createElement('script');
        s.id = 'crisp-chat';
        s.src = 'https://client.crisp.chat/l.js';
        s.async = true;
        document.getElementsByTagName('head')[0].appendChild(s);
      }
    }
  }
}


export const wrapRootElement = ({ element }) => {
  return (
    <GlobalStateProvider>
      {element}
      <Analytics />
    </GlobalStateProvider>
  );
};


